import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import EventCount from './EventCount'

type PieChartTooltipProps = {
  type: string
  value: number
}

/** Contents of the status donut's tooltip; the chart draws the tooltip surface around it. */
const PieChartTooltip = ({ type, value }: PieChartTooltipProps) => {
  const { t } = useTranslation()

  return (
    <Tooltip>
      <LightText level={2} weight="medium">
        {t('STATUS')}
      </LightText>
      <EventCount type={type} count={value} fixedWidth />
    </Tooltip>
  )
}

const Tooltip = styled.div`
  display: flex;
  flex-direction: column;
`
const LightText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

export default PieChartTooltip
